import React, { Component, Fragment } from 'react'
import Table from '../../../../components/table';
import { connect } from 'react-redux';
import './styles.scss';
import {
    GetPlayerPitchers, ACTIONS_PLAYER, converDataRecord,
    convertDataPerformance, converTrouble
} from '../../../../actions/player-pitchers';
import Loading from '../../../../components/loading';

class PlayerPitcher extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoading: false,
            listRecord : [],
            listPerformance : [],
            listTrouble : []
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        
        
        if (nextProps) {
            if (nextProps.status === ACTIONS_PLAYER.GET_HEADER_PLAYER_PITCHERS_SUCCESS) {
                let info = nextProps.response.common.record_to_be_lasts;
                let performance = nextProps.response.ball_type_performances;
                let trouble = nextProps.response.ordinary_hits_summuries;
                
                this.setState({
                    listRecord: converDataRecord(info),
                    listPerformance: convertDataPerformance(performance),
                    listTrouble: converTrouble(trouble),
                    showLoading: false
                });
            }
        }
    }

    componentDidMount() {
        this.setState({ showLoading: true });
        this.props.GetPlayerPitchers();
    }

    render() {
        return (
            <Fragment>
                <div className='player-pitcher'>
                    <div className="block">
                        <Table header={this.props.headerDeregis}
                            titleTable={this.props.titleDeregis}
                            showCheckbox={false} showSearch={false}
                            itemOfPage={this.props.dataDeregis}
                            isShowOptionTable={false}
                            showPagination={false} />
                    </div>
                    <div className="block">
                        <Table
                            header={this.props.headerAchievement}
                            titleTable={this.props.titleAchievement}
                            showCheckbox={false} showSearch={false}
                            itemOfPage={this.state.listRecord}
                            isShowOptionTable={false} showPagination={false} />
                    </div>

                    <div className="block">
                        <Table header={this.props.headerPitcher1}
                            titleTable={{ text: '球種別投手成績' }}
                            showCheckbox={false} showSearch={false}
                            itemOfPage={this.state.listPerformance}
                            isShowOptionTable={false} showPagination={false} />
                    </div>
                    <div className="block">
                        <Table
                            header={this.props.headerPitcher2}
                            titleTable={{ text: '凡打内訳' }}
                            showCheckbox={false} showSearch={false}
                            itemOfPage={this.state.listTrouble}
                            isShowOptionTable={false} showPagination={false} />
                    </div>
                    </div>
                
                <Loading show={this.state.showLoading} />
                </Fragment>
        );
    }
}

const mapStateToProps = ({ players, playerPitchers }) => {
    return {
        response: playerPitchers.response,
        status: playerPitchers.status,
        headerDeregis: players.headerDeregis,
        dataDeregis: players.dataDeregis,
        titleDeregis: players.titleDeregis,
        titleAchievement: players.titleAchievement,
        headerAchievement: players.headerAchievement,
        playerPitcherData2: players.playerPitcherData2,
        headerPitcher1: players.headerPitcher1,
        headerPitcher2: players.headerPitcher2
    };
}

const mapDispatchToProps = dispatch => {
    return {
        GetPlayerPitchers: (id) => {
            dispatch(GetPlayerPitchers(id));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(PlayerPitcher);